// extracted by mini-css-extract-plugin
module.exports = {"work":"single-module--work--3md4s"};